import React from 'react';

import { Panel, PanelContent, PanelHeader } from '@flixbus/honeycomb-react';

import Loader from 'common/Loader';

import SequenceDetails from './SequenceDetails';
import { ASSIGNMENT_DETAILS_SIDEBAR_TEXT } from './text';
import { useResolvedAssignment } from './useResolvedAssignment';

/**
 * PROPS:
 * - crewMemberId             // required when fullAssignmentData is absent
 * - sequenceGroupId          // required when fullAssignmentData is absent
 * - currentRideId?           // ride clicked by the user; highlights it in multi-ride assignments
 * - fullAssignmentData?      // one element of workAssignmentSearchV2.results[]; bypasses the fetch
 * - onClose                  // injected by ActiveElementsHost
 */
const WorkAssignmentDetails = ({
	crewMemberId,
	sequenceGroupId,
	currentRideId,
	fullAssignmentData,
	breakdown: externalBreakdown,
	onClose,
}) => {
	const { data, loading, error } = useResolvedAssignment({
		crewMemberId,
		sequenceGroupId,
		fullAssignmentData,
	});

	const handleClose = (e) => {
		e.preventDefault();
		e.stopPropagation();
		onClose();
	};

	return (
		<Panel id="assignment-details-widget" active hasOverlay onOverlayClick={handleClose}>
			<PanelHeader
				closeButtonProps={{
					label: ASSIGNMENT_DETAILS_SIDEBAR_TEXT.close,
					onClick: handleClose,
				}}
			>
				{ASSIGNMENT_DETAILS_SIDEBAR_TEXT.waDetails}
			</PanelHeader>

			<PanelContent>
				{loading && (
					<div data-testid="sidebar-loader">
						<Loader />
					</div>
				)}
				{error && <div>{ASSIGNMENT_DETAILS_SIDEBAR_TEXT.errorMsg}</div>}
				{!loading && !error && (
					<SequenceDetails
						result={data}
						currentRideId={currentRideId}
						externalBreakdown={externalBreakdown}
					/>
				)}
			</PanelContent>
		</Panel>
	);
};

export default WorkAssignmentDetails;
